module.exports = __webpack_public_path__ + "static/media/esh-board-march-27@2x.8bc44917.png";